/**
 * The public member/profile URLs are served by the legacy site, whose rewrite rules only accept
 * `[a-z0-9-]` in the name segment. Characters such as `&` (e.g. "Atsumi & Sakai") produce paths
 * like `/member/law-firm/atsumi-&-sakai/10172` that never reach the page, so they are spelled out
 * or dropped here instead of being percent-encoded.
 */
export const slugifyUrlSegment = (value?: string | null): string =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/['’`]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const normalizeId = (id?: string | number | null): string =>
  String(id ?? "").trim();

/** Returns `null` when the link cannot be resolved, so callers can render plain text instead. */
export const buildPersonProfilePath = (
  name?: string | null,
  lastName?: string | null,
  personId?: string | number | null
): string | null => {
  const id = normalizeId(personId);
  const slug = slugifyUrlSegment(`${name ?? ""} ${lastName ?? ""}`);
  if (!id || !slug) {
    return null;
  }
  return `/profile/${slug}/${id}`;
};

export const buildFirmProfilePath = (
  firmName?: string | null,
  firmId?: string | number | null,
  firmType: string = "law-firm"
): string | null => {
  const id = normalizeId(firmId);
  const slug = slugifyUrlSegment(firmName);
  if (!id || !slug) {
    return null;
  }
  return `/member/${slugifyUrlSegment(firmType) || "law-firm"}/${slug}/${id}`;
};
